<template>
  <div class="mt-2">
    <el-row>
      {{ title }}
      <el-col :span="24">
        <div class="form-group">
          <el-checkbox v-model="field.is_hide_question_no">Hide Question Number</el-checkbox>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ["field", "title"],
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>